import { Component } from '@angular/core';
import { PageScrollConfig } from 'ng2-page-scroll';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app works!';

  constructor() {
        PageScrollConfig.defaultScrollOffset = 50;
        PageScrollConfig.defaultDuration = 300;
    }

  	bookClicked(bookScroll: boolean) {
	    console.log("AppComponent bookClicked")
	}
}



// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/app.component.ts